import {
  moduleCrudConfig,
  CRUDRoute,
  defaultModuleConfig,
} from './CRUDConfig'
import { LOGS_SCHEMA_NAME } from '../api/logs'
import panelConfig from './panelConfig'
import { CRUD_PATH } from './constants'

export {
  LOGS_SCHEMA_NAME,
}

const moduleConfig = {
  defaultModuleConfig,
  CRUDRoute,
  CRUD_PATH,
  panelConfig,
  headerConfig: {
    list: {
      title: `Логи`,
      path : `/${LOGS_SCHEMA_NAME}`,
    },
    item: {
      title: `Лог`,
      path : `/${CRUD_PATH}`,
    },
  },
  moduleCrudConfig,
}

export default moduleConfig
